export default __webpack_public_path__ + "static/media/people.d6c473c3.svg";